import React, { useState } from 'react';
import clsx from 'clsx';
import { ProColumns } from '@ant-design/pro-table/es/typing';
import dayjs from 'dayjs';
import { SortOrder } from 'antd/es/table/interface';
import { RequestData } from '@ant-design/pro-table';
import { Tag } from 'antd';
import styles from '../index.module.scss';
import {
  EmailQueueStatusType,
  EmailsQueueStatus,
  EmailsQueueTableRow,
  useEmailsQueueTableGet,
} from '../../../../../hooks/api/inviteUsers';
import Table from '../../../../Common/Table';
import { UserRoleDisplay } from '../../../../../enums/user';
import { dateTimeFormat } from '../../../../../contstant';
import { getSorterParams, queryFilterParams } from '../../../../../utils';

export enum EmailQueueStatusColor {
  'pending' = 'blue',
  'in_progress' = 'processing',
  'done' = 'green',
  'error' = 'red',
}

export enum EmailQueueStatusDisplay {
  'done' = 'Done',
  'pending' = 'Pending',
  'in_progress' = 'In progress',
  'error' = 'Error',
}

export function getUserStatusColor(status: EmailQueueStatusType): string {
  // @ts-ignore take a color from the list
  return EmailQueueStatusColor[status?.toLowerCase()] || 'rgba(0,0,0,.15)';
}

const columns: ProColumns<EmailsQueueTableRow>[] = [
  {
    title: 'Email',
    dataIndex: 'user.email',
    key: 'email',
    sorter: false,
    hideInSearch: true,
    renderText: (_, record) => record.user?.email,
  },
  {
    title: 'Full name',
    dataIndex: 'fullName',
    key: 'fullName',
    sorter: false,
    hideInSearch: true,
    renderText: (_, record) => record.fullName,
  },
  {
    title: 'Role',
    dataIndex: 'user.role',
    key: 'roles', // key - for filters. dataIndex - for display.
    sorter: false,
    valueEnum: UserRoleDisplay,
    hideInSearch: true,
    renderText: (_, record) => record.user?.role,
  },
  {
    order: 10,
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    sorter: false,
    valueEnum: EmailQueueStatusDisplay,
    render: (_, record) => (
      <Tag color={getUserStatusColor(record.status)} className="capitalize-first-letter">{record.status}</Tag>
    ),
  },
  {
    title: 'Error',
    dataIndex: 'errorData',
    key: 'errorData',
    sorter: false,
    hideInSearch: true,
    width: 400,
    render: (_, record) => (
      <code className="text-wrap">
        {`${JSON.stringify(record?.errorData || {}) === '{}' ? '' : JSON.stringify(record.errorData || {})}`}
      </code>
    ),
  },
  {
    title: 'Created at',
    dataIndex: 'createdAt',
    key: 'createdAt',
    hideInSearch: true,
    sorter: false,
    renderText: (text) => dayjs(text).format(dateTimeFormat),
  },
];

function ToolBar() {
  return [];
}

function CollapseItem({ rowData }: { rowData: EmailsQueueStatus}) {
  const { group } = rowData;
  const [tableKey, setTableKey] = useState(Date.now());

  const emailsQueueTableGet = useEmailsQueueTableGet();

  const tableRequest = (
    {
      current,
      pageSize,
      ...args
    }: Record<string, string> & {
      pageSize?: number | undefined;
      current?: number | undefined;
      keyword?: string | undefined;
    },
    sorter: Record<string, SortOrder>,
  ): Promise<Partial<RequestData<EmailsQueueTableRow>>> => {
    const newParams = queryFilterParams({
      page: current ? `${current}` : '1',
      pageSize: pageSize ? `${pageSize}` : '10',
      ...args,
      ...getSorterParams(sorter),
    });

    // setSearchParams({ ...args, ...getSorterParams(sorter) }, { replace: true });

    return emailsQueueTableGet.fetch({
      ...newParams,
      group,
    }).then((response) => {
      if (response) {
        const { data, total: totalResItems } = response;

        return ({
          data: data || [],
          // data: (data || []).map(((item) => ({
          //   ...item,
          //   key: item.user.id,
          // }))),
          success: true,
          total: totalResItems,
        });
      }

      return ({ data: [], success: false, total: 0 });
    });
  };

  return (
    <div className={styles.collapseItem}>
      <Table<EmailsQueueTableRow>
        key={tableKey}
        resetKey={() => setTableKey(Date.now())}
        className={clsx('transparent', 'table-no-padding', 'filter-table-no-padding')}
        headerTitle="Emails list"
        toolBarRender={ToolBar}
        request={tableRequest}
        columns={columns}
        // actions={[]}
        search={{
          searchText: 'Filter',
          resetText: 'Clear',
          style: {
            // display: 'none',
          },
        }}
        form={{
          syncToUrl: false, /** Make table work with local stage, without search */
          initialValues: {
            // status: 'error',
          },
        }}
        options={{
          search: {
            name: 'search',
          },
        }}
      />
    </div>
  );
}

export default CollapseItem;
